/**
 * Configuração da API do dashboard admin.
 * Todas as informações do app (unidades, profissionais, horários, serviços,
 * menu, galeria, contatos, etc.) vêm desta API, gerida pelo dashboard.
 * Em desenvolvimento, use URL vazia para o Vite fazer proxy de /api para o servidor (localhost:3000).
 * Em produção, defina VITE_API_URL no .env (ex.: https://api.seudominio.pt).
 * Na app nativa, a base pode ser injetada em runtime via window.__NATIVE_API_BASE__.
 */

import { getRuntimeApiBase } from '@/config/runtime'

export function getApiBaseUrl(): string {
  return getRuntimeApiBase()
}

/** Compatibilidade — prefira getApiBaseUrl() para ler valor em runtime. */
export const API_BASE_URL = import.meta.env.VITE_API_URL ?? ''

export const ENDPOINTS = {
  menu: '/menu',
  quemSomos: '/quem-somos',
  servicos: '/servicos',
  contatos: '/contatos',
  mapa: '/mapa',
  galeria: '/galeria',
  unidades: '/unidades',
  profissionais: '/profissionais',
  horarios: '/horarios',
  pacotes: '/pacotes',
  vip: '/vip',
  agendamentos: '/agendamentos',
} as const
